import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchMeetingStaffs = (setMeetingStaffOptions: Function, language: string, setLoading: Function) => {
  setLoading((loading: any) => ({ ...loading, meetingStaffs: true }));
  ApiService.get("meetings/resources")
    .then((response) => {
      setMeetingStaffOptions({
        animators: response.data.meeting_staff_and_programs.animators,
        authors: response.data.meeting_staff_and_programs.authors,
      });
    })
    .catch((error) => {
      console.error("Failed to get animators:", error);
      alert(translate(language, "PAGES.USER_ROLES_SCOPES.ERRORS.FETCH_MEETING_STAFFS"));
    })
    .finally(() => {
      setLoading((loading: any) => ({ ...loading, meetingStaffs: false }));
    });
};
